import { formatSaleEndDate, useFormatDate, wixServerData } from '@wix/package-picker-shared';
import React from 'react';
import { useIsSeasonalSale } from '../../hooks';
import { useCurrentModule } from '../ModuleProvider';
export const SaleDisclaimer = () => {
  var _data$discount;
  const module = useCurrentModule();
  const {
    locale,
    geo
  } = wixServerData.get();
  const {
    t
  } = module.internals.useTranslations();
  const formatDate = useFormatDate({
    locale
  });
  const isSeasonalSale = useIsSeasonalSale();
  const {
    data
  } = module.SDK.studioOfferingApiClient.hooks.useFetchOfferingDiscount({});
  if (!isSeasonalSale) {
    return null;
  }
  const expiresAt = data == null || (_data$discount = data.discount) == null ? void 0 : _data$discount.expiresAt;
  if (!expiresAt) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, t('sale.footer.offer', {
    date: formatSaleEndDate({
      saleEndDate: new Date(expiresAt).getTime(),
      geo,
      formatter: formatDate
    })
  }), ' ', t('premium-purchase-plan.studio_sale.footer.revshare_ineligible'));
};
//# sourceMappingURL=SaleDisclaimer.js.map